import {format} from "date-fns";

export default function formatPeriod(startAt: Date, endAt: Date) {
    const startDate = new Date(startAt);
    const endDate = new Date(endAt);

    const formattedStart = format(startDate, 'dd/MM');
    const formattedEnd = format(endDate, 'dd/MM');

    return `${formattedStart} até ${formattedEnd}`;
}
